module.exports = __webpack_public_path__ + "img/selected7-min.c6791e4f.png";